import styled from "@emotion/styled";

import styled from "@emotion/styled";

export const UpperSectionCard = styled.div`
  border: 2px solid #03406c;
  border-radius: 30px;
  padding: 2%;
  height: clamp(180px, 25vw, 300px);
  width: clamp(190px, 30vw, 360px);
  background-color: #fff;
  transition: all 0.3s ease;


 div {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #03406c;
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;           
    font-weight: bold;
  }

  h1 {
    font-size: clamp(1rem, 2vw, 1.3rem);
    font-weight: 600;
    color: #03406c;
    margin-bottom: 8px;
  }

  p {
    font-size: clamp(0.8rem, 1.2vw, 1rem);
    color: #555;
    text-align: start;
  }

  &:hover{
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ddddddff;
  }
`;
